import { render, staticRenderFns } from "./resumelist.vue?vue&type=template&id=27127e79&scoped=true&"
import script from "./resumelist.vue?vue&type=script&lang=js&"
export * from "./resumelist.vue?vue&type=script&lang=js&"
import style0 from "./resumelist.vue?vue&type=style&index=0&id=27127e79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27127e79",
  null
  
)

export default component.exports